import React, {Component} from 'react'
import {MainContext} from "contexts/main.context";
import {withSnackbar} from "notistack";
import {Box, Button, Grid, InputAdornment, MenuItem, TextField, Tooltip, Typography} from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import 'moment/locale/es';
import ArticulosMainTable from "components/helpers/articulos/articulos.main.table";
import {LeyendasDialog} from 'components/helpers/dialogs/leyendas.dialog';
import SubHeader from "components/helpers/subHeader/subHeader";
import {formatPrice, formatQuantity} from "assets/utils";
import './cotizaciones.operation.scss';
import {isMobile, osName} from "react-device-detect";

export class CotizacionesOperation extends Component {
    state = {
        leyendasDialogOpen: false
    };

    onOpenLeyendasDialog = () => this.setState({leyendasDialogOpen: true});
    onCloseLeyendasDialog = () => this.setState({leyendasDialogOpen: false});
    onConfirmLeyendasDialog = (leyenda1, leyenda2, leyenda3, leyenda4) => {
        this.props.onChangeHeaderData('leyenda1', leyenda1);
        this.props.onChangeHeaderData('leyenda2', leyenda2);
        this.props.onChangeHeaderData('leyenda3', leyenda3);
        this.props.onChangeHeaderData('leyenda4', leyenda4);
        this.onCloseLeyendasDialog();
    };

    render() {
        const {loggedUser} = this.context;
        const {leyendasDialogOpen} = this.state;
        const {
            operation, cliente, cotizaciones, id, /*condComerciales, vendedores, */articulos, bonificacionesLitros, headerData, selectedArticulos, importe,
            importeBonificado, totalArticulos, totalLitros, maxArticulos, onChangeHeaderData, onAddArticulos, onEditArticulo, onRemoveArticulos, onChangeDocument
        } = this.props;
        const editable = operation === 'CREATE';

        return (
            <Box className='niquel-cotizaciones-operation'>
                <SubHeader
                    title={'Cotizaciones'}
                    subtitle={operation === 'VIEW' ? 'Revisión de Cotización' : 'Nueva Cotización'}
                    cliente={cliente}
                    options={operation === 'VIEW' ? cotizaciones : undefined}
                    optionsTitle={'Cotización'}
                    optionSelectedId={id}
                    optionsDescriptionSecondaryField={'ingreso'}
                    onChangeOption={onChangeDocument}
                />
                <Box className='container-xl mt-3 mb-3'>
                    <Grid container spacing={3}>
                        <Grid container item md={10}>
                            <Grid container item alignItems='center' spacing={3}>
                                <Grid item>
                                    <TextField
                                        label="Bonificación"
                                        className='mr-2 inputBonificacion'
                                        value={headerData.bonificacion}
                                        onChange={event => onChangeHeaderData('bonificacion', event.target.value)}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                            // Bonificación es temporalmente readonly (03/11/19)
                                            // readOnly: editable === false || (loggedUser.role !== 'A' && loggedUser.role !== 'O'),
                                            readOnly: true
                                        }}
                                    />
                                    <TextField
                                        select
                                        required
                                        label="Lista de Precio"
                                        className='mr-2 select'
                                        value={headerData.listaprecio}
                                        onChange={event => {
                                            onChangeHeaderData('listaprecio', event.target.value);
                                            if (selectedArticulos.length > 0)
                                                this.props.enqueueSnackbar('El cambio de lista de precios solo afectará a los nuevos items que se agreguen a la cotización.')
                                        }}
                                        InputProps={{
                                            readOnly: editable === false
                                        }}
                                    >
                                        {['1', '2', '3', '4', '5', '6'].map(value => (
                                            <MenuItem key={value} value={value}>
                                                Lista {value}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                {/*<Grid item>*/}
                                {/*    <TextField*/}
                                {/*        select*/}
                                {/*        label="Cond. Comercial"*/}
                                {/*        className='mr-2 selectCondComercial'*/}
                                {/*        value={headerData.condcomercial}*/}
                                {/*        onChange={event => onChangeHeaderData('condcomercial', event.target.value)}*/}
                                {/*        InputProps={{*/}
                                {/*            readOnly: editable === false*/}
                                {/*        }}*/}
                                {/*    >*/}
                                {/*        {condComerciales.map(option => (*/}
                                {/*            <MenuItem key={option.id} value={option.id}>*/}
                                {/*                {option.description}*/}
                                {/*            </MenuItem>*/}
                                {/*        ))}*/}
                                {/*    </TextField>*/}
                                {/*</Grid>*/}

                                <Grid item>
                                    <TextField
                                        label="Nota de Compra"
                                        className='mr-2 input'
                                        value={headerData.notacompra}
                                        onChange={event => onChangeHeaderData('notacompra', event.target.value)}
                                        InputProps={{
                                            readOnly: editable === false
                                        }}
                                    />
                                    {(loggedUser.role === 'A' || loggedUser.role === 'S' || loggedUser.role === 'O') && (
                                        <TextField
                                            required
                                            label="Usuario"
                                            className='mr-2 input'
                                            value={headerData.usuario}
                                            onChange={event => onChangeHeaderData('usuario', event.target.value)}
                                            InputProps={{
                                                readOnly: editable === false || (loggedUser.role !== 'A' && loggedUser.role !== 'O')
                                            }}
                                        />
                                    )}
                                    {editable === false && (loggedUser.role === 'A' || loggedUser.role === 'S' || loggedUser.role === 'O') && (
                                        <TextField
                                            required
                                            label="Vendedor"
                                            className='mr-2 input'
                                            value={headerData.vendedor}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    )}
                                </Grid>
                                <Grid item>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            disableToolbar
                                            autoOk
                                            required
                                            className='mr-2 date'
                                            label="Ingreso"
                                            format="DD/MM/Y"
                                            disablePast={editable}
                                            value={headerData.ingreso}
                                            onChange={moment => onChangeHeaderData('ingreso', moment)}
                                            InputProps={{
                                                readOnly: editable === false,
                                                onClick: (e) => editable === false && e.stopPropagation()
                                            }}
                                        />
                                        <DatePicker
                                            disableToolbar
                                            autoOk
                                            required
                                            className='mr-2 date'
                                            label="Entrega"
                                            format="DD/MM/Y"
                                            disablePast={editable}
                                            value={headerData.entrega}
                                            onChange={moment => onChangeHeaderData('entrega', moment)}
                                            InputProps={{
                                                readOnly: editable === false,
                                                onClick: (e) => editable === false && e.stopPropagation()
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Tooltip title='Leyendas'>
                                    <Button color="primary" variant='outlined' className='ml-2' onClick={this.onOpenLeyendasDialog}>
                                        <ListIcon fontSize={"default"} className='mr-1'/>
                                        Leyendas
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Grid>
                        <Grid container item md={2} direction={"column"} spacing={1}>
                            <Tooltip title={formatPrice(importe, true) + ' - ' + formatPrice(headerData.bonificacion) + '% (total - bonificación)'}>
                                <Grid item>
                                    <Typography variant={"caption"} display="block" align="right" color={"textSecondary"}>Total Bonificado</Typography>
                                    <Typography variant="h6" align="right">{formatPrice(importeBonificado, true)}</Typography>
                                </Grid>
                            </Tooltip>
                            <Grid item>
                                <Typography variant="caption" display="block" align="right" color={"textSecondary"}>Total sin Bonificar</Typography>
                                <Typography variant="subtitle1" align='right'>{formatPrice(importe, true)}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Box className='coti-articulos'>
                        <ArticulosMainTable
                            articulos={articulos}
                            selected={selectedArticulos}
                            editable={editable}
                            maxArticulos={maxArticulos}
                            listaprecio={`lista${headerData.listaprecio}`}
                            bonificacionesLitros={bonificacionesLitros}
                            importe={importe}
                            totalArticulos={totalArticulos}
                            importeArticulos={importe}
                            totalLitros={totalLitros}
                            bonificacionGeneral={headerData.bonificacion}
                            cliente={cliente}
                            onAdd={onAddArticulos}
                            onEdit={onEditArticulo}
                            onRemove={onRemoveArticulos}
                        />
                    </Box>

                    <LeyendasDialog
                        open={leyendasDialogOpen}
                        editable={editable}
                        leyenda1={headerData.leyenda1}
                        leyenda2={headerData.leyenda2}
                        leyenda3={headerData.leyenda3}
                        leyenda4={headerData.leyenda4}
                        onConfirm={this.onConfirmLeyendasDialog}
                        onCancel={this.onCloseLeyendasDialog}
                        fullScreen={(isMobile || osName === 'Android')}
                    />
                </Box>
            </Box>
        )
    }
}

CotizacionesOperation.contextType = MainContext;
CotizacionesOperation = withSnackbar(CotizacionesOperation);
CotizacionesOperation.defaultProps = {
    operation: 'CREATE',
    cliente: {},
    cotizaciones: [],
    condComerciales: [],
    vendedores: [],
    articulos: [],
    headerData: {
        bonificacion: 0,
        listaprecio: '1',
        condcomercial: '',
        notacompra: '',
        usuario: '',
        vendedor: '',
        ingreso: (new MomentUtils()).date(new Date()),
        entrega: (new MomentUtils()).date(new Date()),
        leyenda1: '',
        leyenda2: '',
        leyenda3: '',
        leyenda4: ''
    },
    selectedArticulos: [],
    importe: 0,
    importeBonificado: 0
};
